








































































import { cloneDeep } from "lodash";
import { Vue, Component, PropSync, Prop, Watch, Emit } from 'vue-property-decorator';

import { captureScreenshot } from "../../logic/captureScreenshot";
import { SelectedFileWithPreviewToUpload } from "../../logic/filesToUpload";
import { FileType } from "../../types";
import InputUpload from "../InputUpload.vue";

type ThumbnailScreen = 'uploadType' | 'screenshot'

@Component({
  data() {
    return {
      FileType
    }
  },
  components: {
    InputUpload
  }
})
export default class UploadThumbnailModal extends Vue {
  @Prop() currentItem!: SelectedFileWithPreviewToUpload | null

  @Prop() selectedType!: FileType

  @PropSync('visible', { type: Boolean }) isModalOpen!: boolean

  @Watch('currentItem', { deep: true })
  onCurrentItemChange() {
    this.currentItemCopy = cloneDeep(this.currentItem)
  }

  @Emit()
  updateCurrentItem(item: SelectedFileWithPreviewToUpload) {
    return item
  }

  currentItemCopy: SelectedFileWithPreviewToUpload | null = null

  thumbnailTypeScreen: ThumbnailScreen = "uploadType"

  resetThumbnail() {
    if (this.currentItemCopy?.item) {
      this.currentItemCopy.item.thumbFile = null
      this.currentItemCopy.item.thumbUrl = '';

      this.updateCurrentItem(this.currentItemCopy)
    }
  }

  resetThumbnailModalState() {
    this.isModalOpen = false;

    this.thumbnailTypeScreen = "uploadType";
  }

  change(event: InputEvent) {
    if (event.target && event.target instanceof HTMLInputElement && event.target.files && this.currentItemCopy?.item) {
      this.currentItemCopy.item.thumbFile = event.target.files[0]
      this.currentItemCopy.item.thumbUrl = window!.URL.createObjectURL(event.target.files[0])

      this.updateCurrentItem(this.currentItemCopy)

      this.resetThumbnailModalState()
    }
  }

  doScreen() {
    const screenshot = captureScreenshot()

    if (screenshot instanceof Promise) {
      screenshot.then(res => {
        if (res && this.currentItemCopy && this.currentItemCopy.item && this.currentItemCopy.index !== null) {
          this.currentItemCopy.item.thumbFile = res
          this.currentItemCopy.item.thumbUrl = window!.URL!.createObjectURL(res)

          this.updateCurrentItem(this.currentItemCopy)

          this.resetThumbnailModalState()
        }
      })
    }
  }
}
